// Snuggle Club cart: slide-out drawer on every page + full cart page (#cartPage). Uses Shopify's /cart/*.js endpoints.
(function(){
  const UPSELL=window.SNUGGLE_UPSELL||null; // {id, title, price, img, href}
  const fmt=(c,cur)=>new Intl.NumberFormat('en-US',{style:'currency',currency:cur||'USD'}).format(c/100);
  const esc=s=>String(s).replace(/[&<>"]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]));
  const img=(u,w)=>u?u+(u.includes('?')?'&':'?')+'width='+(w||240):'';

  document.body.insertAdjacentHTML('beforeend',`
  <div class="cd-scrim" id="cdScrim"></div>
  <aside class="cd" id="cd" aria-label="Your cart" aria-hidden="true">
    <div class="cd-h"><h2>Your <em>cart</em> <span id="cdCount"></span></h2><button class="cd-x" id="cdX" aria-label="Close cart">✕</button></div>
    <div class="cd-body" id="cdBody"></div>
  </aside>`);
  const $=id=>document.getElementById(id);

  function lineHTML(it,cur){
    const disc=(it.line_level_discount_allocations||[]).map(d=>d.discount_application&&d.discount_application.title).filter(Boolean);
    const struck=it.original_line_price>it.final_line_price?`<s>${fmt(it.original_line_price,cur)}</s>`:'';
    return `<div class="cl" data-key="${it.key}">
      <a class="cl-img" href="${it.url}"><img src="${img(it.image,200)}" alt="${esc(it.product_title)}"></a>
      <div class="cl-i">
        <div class="cl-t"><a href="${it.url}">${esc(it.product_title)}</a><span class="cl-p">${struck}${fmt(it.final_line_price,cur)}</span></div>
        ${it.variant_title?`<div class="cl-v">${esc(it.variant_title.replace(' / ',' · '))}</div>`:''}
        ${disc.length?`<div class="cl-d">♡ ${esc(disc[0])}</div>`:''}
        <div class="cl-r">
          <div class="cl-q"><button data-q="${it.quantity-1}" aria-label="Less">−</button><span>${it.quantity}</span><button data-q="${it.quantity+1}" aria-label="More">+</button></div>
          <button class="cl-rm" data-q="0">Remove</button>
        </div>
      </div></div>`;
  }
  function render(cart){
    const cur=cart.currency, n=cart.item_count;
    document.querySelectorAll('.cart-count').forEach(b=>{b.textContent=n;b.hidden=!n});
    $('cdCount').textContent=n?`(${n})`:'';
    const blankets=cart.items.filter(i=>i.handle=='the-original-plush').reduce((a,i)=>a+i.quantity,0);
    const nudge=blankets==1?`<div class="cd-note">Add a 2nd blanket, get it 50% off ♡</div>`:(blankets>=2?`<div class="cd-note on">Your 2nd blanket is 50% off ♡</div>`:'');
    const up=UPSELL&&!cart.items.some(i=>i.variant_id==UPSELL.id)&&n?`<div class="cd-up"><img src="${img(UPSELL.img,160)}" alt=""><div><b>${esc(UPSELL.title)}</b><span>Matches your blanket · ${fmt(UPSELL.price*100,cur)}</span></div><button id="cdUp">Add</button></div>`:'';
    const html=n?`
      <div class="cd-ship">♡ Free shipping on your order</div>${nudge}
      <div class="cd-lines">${cart.items.map(i=>lineHTML(i,cur)).join('')}</div>
      ${up}
      <div class="cd-f">
        ${cart.total_discount?`<div class="cd-row save"><span>You save</span><span>−${fmt(cart.total_discount,cur)}</span></div>`:''}
        <div class="cd-row"><span>Shipping</span><span>Free</span></div>
        <div class="cd-row tot"><span>Total</span><span>${fmt(cart.total_price,cur)}</span></div>
        <a class="atc cd-go" href="/checkout">Checkout · ${fmt(cart.total_price,cur)}</a>
        <p class="cd-small">30-night trial · Secure checkout · Taxes calculated at checkout</p>
      </div>`:`
      <div class="cd-empty"><p class="sec-h">Your cart is <em>empty</em></p><p>Let's fix that.</p><a class="atc" href="/">Shop The Original Plush</a></div>`;
    $('cdBody').innerHTML=html;
    const page=$('cartPage'); if(page) page.innerHTML=html;
  }
  async function refresh(){const c=await fetch('/cart.js').then(r=>r.json());render(c);return c}
  async function change(key,q){
    document.querySelectorAll(`.cl[data-key="${key}"]`).forEach(e=>e.classList.add('busy'));
    const c=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(r=>r.json());
    render(c);
  }
  function open(){refresh();$('cd').classList.add('open');$('cdScrim').classList.add('open');$('cd').setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden'}
  function close(){$('cd').classList.remove('open');$('cdScrim').classList.remove('open');$('cd').setAttribute('aria-hidden','true');document.documentElement.style.overflow=''}
  async function add(items){
    const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
    if(r.ok)open();return r.ok;
  }
  document.addEventListener('click',e=>{
    const q=e.target.closest('[data-q]'); const line=e.target.closest('.cl');
    if(q&&line){e.preventDefault();change(line.dataset.key,+q.dataset.q);return}
    if(e.target.closest('#cdUp')){add([{id:UPSELL.id,quantity:1}]);return}
    if(e.target.closest('#cdX,#cdScrim')){close();return}
    const cb=e.target.closest('a[href="/cart"]'); if(cb&&!$('cartPage')){e.preventDefault();open()}
  });
  document.addEventListener('keydown',e=>{if(e.key=='Escape')close()});
  window.SnuggleCart={open,close,add,refresh};
  refresh();
})();
